<h1 mat-dialog-title>Expiring Sesssion</h1>
<div mat-dialog-content>
  <p>Your session is about to expire.  If you do not reset your session, the system will delete your session.</p>
  <p>Time remaining: {{TIMEOUT - (secondsRemaining$ | async)}} seconds</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close]="true" tabindex="-1">Reset</button>
</div>